import * as Select from '@studio/design-system/select';
import { useMemo } from 'react';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { FilterProps } from './types.js';

/** `<Filter>` component. */
export const Filter = <K extends string>({
  available,
  className,
  selection,
  ...props
}: FilterProps<K>): ReactElement => {
  const items = useMemo(
    () => (
      <>
        {available.map(([k, v]) => (
          <Select.Item key={k} value={k}>
            {v}
          </Select.Item>
        ))}
      </>
    ),
    [available]
  );

  return (
    <div
      className={twMerge('mx-16 my-12 flex items-center rounded bg-base-100', className)}
      {...props}
    >
      <div className='w-[65px] text-center text-sm text-muted'>Filter by</div>

      <Select.Root onValueChange={selection.setValue} value={selection.value}>
        <Select.Trigger className='grow rounded-l-none border-l border-base-300 bg-transparent text-sm'>
          <Select.Value />
        </Select.Trigger>

        <Select.Content>{items}</Select.Content>
      </Select.Root>
    </div>
  );
};
